module.exports = __webpack_public_path__ + "img/image-1.24b9feaa.jpg";